import { data } from '../../svg/Message/data';
import { makeIcon } from '../makeIcon';

export const Message = makeIcon(data, 'message', 'Message');

export default Message;
